import { Pipe, PipeTransform } from '@angular/core';
import { DprCard } from '@dpr/models';

@Pipe({ name: 'displayESignButton' })
export class DisplayESignButtonPipe implements PipeTransform {
  transform(
    data: DprCard,
    isAppOnline: boolean,
    isDigitalSignatureEnabled: boolean
  ): boolean {
    return (
      isDigitalSignatureEnabled &&
      isAppOnline &&
      data &&
      // report not uploaded or uploaded using E-Sign
      (!data.isSignDprDetailsUploaded ||
        (data.isSignDprDetailsUploaded && !!data.dprReportSignRequestId))
    );
  }
}
